import React from "react";

import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row,
  FormText,
} from "reactstrap";

import SelectListComponent from "../utils/selectList";
import DateSelector from "../utils/dateSelector";

const ReportsPanel = ({
  travelRoutes,
  selectedTravelRoute,
  onTravelRouteValueChange,
  onSearch,
  startDateChange,
  endDateChange,
  SourceAirlineId,
  handleSelectChange,
  componentErrorMessages,
  airlines,
  requesting,
  handleAirlineSelectChange,
}) => {
  return (
    <Form onSubmit={(e) => e.preventDefault()}>
      <Container>
        <Row>
          <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>Start Date</Label>
              <DateSelector
                maxDate={new Date()}
                todayDate={new Date().toString()}
                name="startDate"
                onValueChange={startDateChange}
                // dayNotAllowed={true}
              />
            </FormGroup>
          </Col>
          <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>End Date</Label>
              <DateSelector
                maxDate={new Date()}
                todayDate={new Date().toString()}
                name="endDate"
                onValueChange={endDateChange}
                // dayNotAllowed={true}
              />
            </FormGroup>
          </Col>
          <Col xs="6" sm="2">
            <FormGroup
              className={
                "mb-0 " +
                (componentErrorMessages.SourceAirlineId ? "has-danger" : "")
              }
            >
              <Label>Airline</Label>
              <SelectListComponent
                placeholder={"Select airline..."}
                data={airlines}
                valueKey="Id"
                textField="Name"
                selectValue={SourceAirlineId || []}
                onValueChange={(event) => {
                  handleAirlineSelectChange(event, "Id", "SourceAirlineId");
                }}
                multiSelectMode={true}
s              />
              {componentErrorMessages.SourceAirlineId && (
                <FormText color="danger">
                  {" "}
                  {componentErrorMessages.SourceAirlineId}
                </FormText>
              )}
            </FormGroup>
          </Col>
          <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>Travel Route</Label>
              <SelectListComponent
                data={travelRoutes}
                valueKey="value"
                textField="label"
                selectValue={selectedTravelRoute}
                onValueChange={onTravelRouteValueChange}
              />
            </FormGroup>
          </Col>

          <Col xs="6" sm="1">
            <label>&nbsp;</label>
            <Button
              disabled={requesting}
              className="btn-avi-primary"
              onClick={() => onSearch()}
            >
              Generate
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};

export default ReportsPanel;



// WEBPACK FOOTER //
// ./src/views/passenger-level-data/reports-panel.js